module.exports = __webpack_public_path__ + "01464e097a8d4db3c7d52ad9c9cc8adf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/social-media-icons/link.png
// module id = 3001
// module chunks = 0